<svg
  *ngIf="qrSize; else empty"
  class="qr-code-preview"
  [attr.viewBox]="'0 0 ' + qrSize + ' ' + qrSize"
  [attr.width]="qrSize"
  [attr.height]="qrSize"
  [attr.aria-label]="ariaLabel"
  shape-rendering="crispEdges"
  role="img"
>
  <rect [attr.width]="qrSize" [attr.height]="qrSize" [attr.fill]="background"></rect>
  <rect
    *ngFor="let cell of cells; trackBy: trackByIndex"
    [attr.x]="cell.x"
    [attr.y]="cell.y"
    [attr.width]="cell.w"
    [attr.height]="cell.h"
    [attr.fill]="cell.color"
  ></rect>
</svg>

<ng-template #empty>
  <div class="qr-code-preview qr-code-preview--empty"></div>
</ng-template>
